import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ShoppingBag, MessageCircle } from "lucide-react";
import { LINKS } from "../data/site";

export default function ProductModal({ product, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {product && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
          data-testid="product-modal"
          className="fixed inset-0 z-[90] grid place-items-center bg-ink/60 p-4 backdrop-blur-md"
        >
          <motion.div
            initial={{ scale: 0.88, y: 36, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.94, y: 16, opacity: 0 }}
            transition={{ type: "spring", stiffness: 230, damping: 24 }}
            onClick={(e) => e.stopPropagation()}
            className="relative grid w-full max-w-3xl overflow-hidden rounded-[2rem] bg-cream shadow-2xl md:grid-cols-2"
            data-testid="product-modal-panel"
          >
            <img src={product.img} alt={product.title} className="h-56 w-full object-cover md:h-full" />
            <div className="flex flex-col justify-center p-6 sm:p-9">
              <span className="mb-3 w-fit rounded-full bg-goldy px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider text-ink">
                {product.badge}
              </span>
              <h3 className="font-display text-2xl font-bold text-ink sm:text-3xl">{product.title}</h3>
              <p className="mt-3 text-sm font-medium leading-relaxed text-inksoft sm:text-base">{product.desc}</p>

              <div className="mt-7 flex flex-col gap-3">
                <a
                  href={LINKS.shopee}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="modal-shopee-cta"
                  className="flex items-center justify-center gap-2 rounded-full bg-shopee px-6 py-3.5 text-sm font-extrabold text-white transition-transform duration-300 hover:scale-[1.03] hover:bg-shopeedark"
                >
                  <ShoppingBag size={17} />
                  Comprar na Shopee
                </a>
                <a
                  href={LINKS.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="modal-whatsapp-cta"
                  className="flex items-center justify-center gap-2 rounded-full bg-wa px-6 py-3.5 text-sm font-extrabold text-white transition-transform duration-300 hover:scale-[1.03] hover:bg-wadark"
                >
                  <MessageCircle size={17} />
                  Pedir no WhatsApp
                </a>
              </div>
            </div>

            <button
              onClick={onClose}
              data-testid="product-modal-close"
              aria-label="Fechar detalhes do produto"
              className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-white/90 text-ink shadow-md transition-transform duration-300 hover:rotate-90 hover:scale-110"
            >
              <X size={18} />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
